import React from 'react'
import { Box, Container, Grid, Text, Button } from '@mantine/core'
import ImgHeaderTraining from '../../../assets/img/ImgHeaderTraining.png'
import classes from '../../../pages/Bootcamp/Bootcamp.module.css'
import { useViewportSize } from '@mantine/hooks'

const TrainingHeader = ({ handleScroll }) => {
  const { width } = useViewportSize()
  return (
    <Box className={classes.headerSection} py={width > 768 ? 120 : 80} style={{ backgroundImage: `url(${ImgHeaderTraining}?dim=500x500)`}}>
      <Container fluid className={classes.section}>
        <Box className={classes.innerHeader}>
          <Box className={classes.contentHeader}>
            <Grid justify="start" align="center">
              <Grid.Col span={{ base: 12, lg: 7 }}>
                <Box className={classes.paddingPage}> 
                  <Text className={classes.titleHeader} mb={16}>Optimalkan Potensi, Wujudkan Masa Depan Berkelanjutan</Text>
                  <Text className={classes.captionHeader} mb={24}>Ikuti program pelatihan dan webinar yang dirancang untuk meningkatkan kompetensi anda. Bersama kami, Anda dapat mengembangkan keterampilan teknis dan manajerial yang diperlukan untuk menghadapi tantangan masa kini dan mendatang.</Text>
                  <Button color="indigo.9" className={classes.buttonHeader} fz={16} radius="md" onClick={handleScroll}>
                    <Text p={4} fw={600} fz={width > 768 ? 12 : 10}>Pilih Pelatihan</Text>
                  </Button>
                </Box>
              </Grid.Col>
            </Grid>
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default TrainingHeader